import React from 'react';

export const NewUserBadgeIcon = ({ width = 160, height = 160 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_433_459)">
      <path
        d="M54.1461 21.5118C69.1281 9.04601 90.8719 9.04601 105.854 21.5118V21.5118C109.392 24.4557 113.407 26.7736 117.725 28.3657V28.3657C136.012 35.1076 146.884 53.9384 143.579 73.1461V73.1461C142.799 77.682 142.799 82.318 143.579 86.8539V86.8539C146.884 106.062 136.012 124.892 117.725 131.634V131.634C113.407 133.226 109.392 135.544 105.854 138.488V138.488C90.8719 150.954 69.1281 150.954 54.1461 138.488V138.488C50.608 135.544 46.5932 133.226 42.2747 131.634V131.634C23.988 124.892 13.1161 106.062 16.4208 86.8539V86.8539C17.2012 82.318 17.2012 77.682 16.4208 73.1461V73.1461C13.1161 53.9384 23.988 35.1076 42.2747 28.3657V28.3657C46.5932 26.7736 50.608 24.4557 54.1461 21.5118V21.5118Z"
        fill="#2AAF4B"
      />
      <path
        d="M54.1461 21.5118C69.1281 9.04601 90.8719 9.04601 105.854 21.5118V21.5118C109.392 24.4557 113.407 26.7736 117.725 28.3657V28.3657C136.012 35.1076 146.884 53.9384 143.579 73.1461V73.1461C142.799 77.682 142.799 82.318 143.579 86.8539V86.8539C146.884 106.062 136.012 124.892 117.725 131.634V131.634C113.407 133.226 109.392 135.544 105.854 138.488V138.488C90.8719 150.954 69.1281 150.954 54.1461 138.488V138.488C50.608 135.544 46.5932 133.226 42.2747 131.634V131.634C23.988 124.892 13.1161 106.062 16.4208 86.8539V86.8539C17.2012 82.318 17.2012 77.682 16.4208 73.1461V73.1461C13.1161 53.9384 23.988 35.1076 42.2747 28.3657V28.3657C46.5932 26.7736 50.608 24.4557 54.1461 21.5118V21.5118Z"
        fill="url(#paint0_radial_433_459)"
        fill-opacity="0.3"
      />
    </g>
    <path
      d="M103.132 52.3597C103.133 52.3601 103.133 52.3607 103.133 52.3613L100.38 71.799C100.122 73.625 100.775 75.4617 102.129 76.7142L116.699 90.1954C117.888 91.2951 117.31 93.2613 115.719 93.5219L96.2987 96.7039C94.4563 97.0058 92.8839 98.2025 92.1021 99.8978L83.9169 117.647C83.2461 119.101 81.1839 119.139 80.4263 117.711L71.1355 100.201C70.2777 98.5845 68.6866 97.4865 66.8706 97.258L47.2038 94.7842C45.5994 94.5826 44.9038 92.6409 46.0251 91.4979L59.7153 77.5479C61.023 76.2154 61.5839 74.3207 61.2125 72.4911L57.297 53.2048C56.9762 51.625 58.6095 50.3872 60.0594 51.1086L77.8332 59.9479C79.4845 60.7691 81.4335 60.7283 83.049 59.8387L100.246 50.3683C101.652 49.5951 103.357 50.7715 103.131 52.3582C103.131 52.3588 103.132 52.3594 103.132 52.3597V52.3597Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.9955 135.618C50.0863 133.549 46.9121 131.872 43.5543 130.634C34.7371 127.384 27.6437 121.322 23.0321 113.764C25.8874 111.931 28.5925 110.014 31.0404 108.035C32.1876 107.108 33.7183 106.786 35.1229 107.236L42.8836 109.727C45.5547 107.25 48.0467 104.704 50.2363 102.143C51.195 101.022 52.6412 100.426 54.1045 100.613L64.8305 101.982C66.1819 102.155 67.3668 102.969 68.0118 104.169L75.4188 117.951C76.3121 119.613 75.9933 121.685 74.5785 122.933C67.661 129.037 60.2876 133.059 52.9955 135.618Z"
      fill="white"
    />
    <g filter="url(#filter1_i_433_459)">
      <path
        d="M54.1461 21.5118C69.1281 9.04601 90.8719 9.04601 105.854 21.5118V21.5118C109.392 24.4557 113.407 26.7736 117.725 28.3657V28.3657C136.012 35.1076 146.884 53.9384 143.579 73.1461V73.1461C142.799 77.682 142.799 82.318 143.579 86.8539V86.8539C146.884 106.062 136.012 124.892 117.725 131.634V131.634C113.407 133.226 109.392 135.544 105.854 138.488V138.488C90.8719 150.954 69.1281 150.954 54.1461 138.488V138.488C50.608 135.544 46.5932 133.226 42.2747 131.634V131.634C23.988 124.892 13.1161 106.062 16.4208 86.8539V86.8539C17.2012 82.318 17.2012 77.682 16.4208 73.1461V73.1461C13.1161 53.9384 23.988 35.1076 42.2747 28.3657V28.3657C46.5932 26.7736 50.608 24.4557 54.1461 21.5118V21.5118Z"
        stroke="#208639"
        stroke-width="4"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_433_459"
        x="15.8318"
        y="12.1625"
        width="128.336"
        height="147.104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.4286" />
        <feGaussianBlur stdDeviation="11.4286" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_433_459"
        />
      </filter>
      <filter
        id="filter1_i_433_459"
        x="13.8316"
        y="10.1625"
        width="132.337"
        height="151.104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.4286" />
        <feGaussianBlur stdDeviation="11.4286" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_433_459"
        />
      </filter>
      <radialGradient
        id="paint0_radial_433_459"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66 108) rotate(145.008) scale(73.2393)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
